import React, { useState } from 'react'
import { CardPoster } from '../utilities/constants'

const MovieCard = ({posterPath}) => {
  const [errored, setErrored] = useState(false);
  if (errored || !posterPath) return null;

  return (
    <div className="flex-shrink-0 w-48 p-2">
      <img
        alt="movie card"
        src={/^https?:\/\//.test(posterPath) ? posterPath : CardPoster + posterPath}
        onError={() => setErrored(true)}
      />
    </div>
  )
}

export default MovieCard;